module.exports = __webpack_public_path__ + "media/images/ln/constellation_04-7949c31372e01b1ab976a813eaa6164a.png";